import React, { useEffect, useState, useCallback, useRef } from "react";
import "./index.css";
import Autocomplete from "react-google-autocomplete";
import axios from "../axios";
import axios2 from "axios";
import { parsePhoneNumberFromString, validatePhoneNumberLength } from "libphonenumber-js/max";
import { API_BASE_URL } from "../config";
import Faq from "react-faq-component";
import { useNavigate } from "react-router-dom";
import { genderConversion, modeOfTutionconversion } from "../constants/form-templates";
import { countryDialCodes } from "../constants/countryDialCodes";
import { countryMobileLengths } from "../constants/countryMobileLengths";
import FooterPage from "../components/footerpage";
import TutorRegistration from "../components/tutor-registration";
import DemoClass from "../components/demo-class";
import BlogCard from "../components/blog-card";
import WhyChooseHomeShiksha from "../components/WhyChooseHomeShiksha";
import ExploreCategoriesSection from "../components/ExploreCategoriesSection";
import TutoringCountries from "../components/TutoringCountries";
import PerfectOnlineTutors from "../components/PerfectOnlineTutors/PerfectOnlineTutors";
const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const data = {
  // title: "FAQ (How it works)",

  rows: [
    {
      title: "Do you provide home tutors at my door step? ",
      content: `Yes, HomeShiksha provide both “Home Tutors at your doorstep” and “Online Tutors” as per 
          your need`,
    },
    {
      title: " Do you also provide tutor for extracurricular activities? ",
      content: `Yes, HomeShiksha provide tutors for dancing, singing, Painting, cooking and many other co-
          curricular activities. `,
    },
    {
      title: " Do you provide free demo class before we finalise with any tutor? ",
      content: `Yes, we provide free demo class. You can have demo sessions with our tutors to select the 
          best one as per your need.`,
    },
    {
      title: "Do you provide female tutors for female candidates?  ",
      content: `Yes, we provide female tutors for female students.`,
    },
    {
      title: "How many tutors can we try for demo classes? ",
      content: `Normally, the first tutor provided by our team would be the best one. However, if you and 
          your kid are not comfortable with the tutor then we would go ahead with a 2nd option. `,
    },
    {
      title: "Can we replace a tutor after a month or two in case if we don't like the tutor? ",
      content: `Yes, obviously you can change tutor at any time, we just request parents to inform us 15days 
          prior to find the replacement. `,
    },
    {
      title: "How many replacement of tutors can be Provided by HomeShiksha?",
      content: `We don't have any limitations in your tutor replacement. Whenever you want tutor needs to 
          be replaced, then Our team will help you with replacement.`,
    },
    {
      title: "How soon HomeShiksha provides the Tutor once we give our tuition requirement?  ",
      content: `Our team works manually to find the best tutor as per your requirement.  
          If you need “Online tutor” then within 1-5 hours you get a tutor. 
          If you are looking for “Home Tutor at your door step” then generally it take 1-7 working 
          days to get the best tutor.`,
    },
  ],
};

const styles = {
  bgColor: "white",
  titleTextColor: "Black",
  rowTitleColor: "Black",
  rowContentColor: "grey",
  arrowColor: "black",
};

const config = {
  animate: true,
  // arrowIcon: "V",
  tabFocus: true,
  expandIcon: "+",
  collapseIcon: "-",
};

const slides = [
  {
    image: "./teacher_tutor.png",
    title: "Nupur Mittal",
    description: "Maths Teacher ,  3+ year experience.",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_1.png",
    title: "Chandini Chabra - Dance Teacher",
    description: "National level dancer, 8+ dance style.",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_2.png",
    title: "Naina Sinha - Music Teacher",
    description: "Experience in various styles of musics",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_3.png",
    title: "Reema Jain - Physics Teacher",
    description: "5 Years experience of teaching physics",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_5.png",
    title: "Name - Expertise",
    description: "s simply dummy text of the printing and typesetting industry. ",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_6.png",
    title: "Name - Expertise",
    description: "s simply dummy text of the printing and typesetting industry. ",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_7.png",
    title: "Name - Expertise",
    description: "s simply dummy text of the printing and typesetting industry. ",
    clickEvent: () => { },
  },
  {
    image: "./teacher_tutor_8.png",
    title: "Name - Expertise",
    description: "s simply dummy text of the printing and typesetting industry. ",
    clickEvent: () => { },
  },
];

const categorys = {
  "school education": "1",
  Curricular: "2",
  "Competitive Exams": "3",
  "Intermediate Courses": "4",
  "Abroad Exams": "5",
  "Learn Language": "6",
  "IT Courses": "7",
  "Special Kids (ADHD /ADD /AUTISM)": "13",
  1: "school education",
  2: "Curricular",
  3: "Competitive Exams",
  4: "Intermediate Courses",
  5: "Abroad Exams",
  6: "Learn Language",
  7: "IT Courses",
  13: "Special Kids (ADHD /ADD /AUTISM)",
};

const blogPosts1 = [
  {
    id: 1,
    imageSrc: "./feature_1.png",
    imageAlt: "Student learning online with tutor",
    category: "Education",
    description: "Hyderabad Edtech Startup is Revolutionizing Home Tuitions Industry in India",
    link: "https://rvrising.com/education/how-hyderabad-edtech-startup-is-revolutionizing-home-tuitions-industry-in-india/",
  },
  {
    id: 2,
    imageSrc: "./feature_2.png",
    imageAlt: "Tutor teaching in classroom",
    category: "Education",
    description: "How Hyderabad based startup is helping special needs children with dyslexia, Autism, etc",
    link: "https://attentionpedia.com/news/education/how-hyderabad-based-startup-is-helping-autismadhd-dyslexia-and-special-needs-children/",
  },
  {
    id: 3,
    imageSrc: "./feature_3.png",
    imageAlt: "Girl studying with laptop",
    category: "Education",
    description: "Hyderabad Startup HomeShiksha is Empowering Women to Shape the Future of EdTech industry",
    link: "https://medium.com/@homeshiksha.seo/how-homeshiksha-empowering-women-to-shape-the-future-of-edtech-e14d80acbde7",
  },
];

const successStories = [
  {
    id: 1,
    text: "I was looking for an online teacher to help my son in learning. Came across this platform online. I registered to prioritize assigning online tutors. The team coordinated well in assigning an online tutor for a demo based on my convenient time. Finally we found a tutor and my son's learning journey has started.",
    name: "Sudha Mathur",
    role: "India",
    avatarSrc: "./review.png",
    avatarAlt: "Sudha Mathur testimonial",
  },
  {
    id: 2,
    text: "It's a very great platform to get qualified online tutor. HomeShiksha helped us to get a tutor for my child. The staffs were very helpful and CRE helped us to get a very qualified tutor in a very short time. I would recommend HomeShiksha and like to thank them for their valuable service.",
    name: "Sophia",
    role: "Dubai",
    avatarSrc: "./review1.png",
    avatarAlt: "Sophia testimonial",
  },
  {
    id: 3,
    text: "I have been using their Online Tutor services since 3 years. Excellent services and guidance. Team is very keen and dedicated mentorship is provided. They take care of all your requirements regarding a good tutor.",
    name: "Apoorva",
    role: "India",
    avatarSrc: "./review2.png",
    avatarAlt: "Apoorva testimonial",
  },
  {
    id: 4,
    text: "I have had great experience with HomeShiksha so far. They made the process quite smooth as well. Highly recommend.",
    name: "Vidhesha",
    role: "India",
    avatarSrc: "./review3.png",
    avatarAlt: "Vidhesha testimonial",
  },
  {
    id: 5,
    text: "Thanks Home Shiksha for providing me with the best Online tutor for my child, with no fuss at all. The service you guys provide is really above par with the rest. Tutors are well behaved, punctual, knowledgeable and efficient.",
    name: "Liam Smith",
    role: "USA",
    avatarSrc: "./review4.png",
    avatarAlt: "Liam Smith testimonial",
  },
  {
    id: 6,
    text: "Homeshiksha is really doing a wonderful job. The tutors that have been provided are really knowledgeable and good at their job. One of the best parts is that they provide female tutor for female candidates.",
    name: "Laxmi Apannavar",
    role: "India",
    avatarSrc: "./review5.png",
    avatarAlt: "Laxmi Apannavar testimonial",
  },
  {
    id: 7,
    text: "I am content with Homeshiksha Tutorial Platform services. As parents we get verified and quality tutor for our children. Throughout the process the team has been very supportive. Highly recommend this to my friends.",
    name: "Amrit Singh",
    role: "Canada",
    avatarSrc: "./review6.png",
    avatarAlt: "Amrit Singh testimonial",
  },
  {
    id: 8,
    text: "Home Shiksha helped us to get a tutor for my child. The staffs especially were very helpful and they helped us to get a very good tutor in a very short time. I would recommend Home Shiksha and like to thank them for their invaluable service.",
    name: "Shreyash",
    role: "New Zealand",
    avatarSrc: "./review7.png",
    avatarAlt: "Shreyash testimonial",
  },
];

const makeTitleGeneric = string => {
  try {
    let arr = string.split(" ");
    arr = arr.map(itm => itm.charAt(0).toUpperCase() + itm.slice(1));
    return arr.join(" ");
  } catch (error) {
    return string;
  }
};

const SearchableDropdown = React.memo(({ field, index, step, options, handledropDownOptionClick, setForm }) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter options based on search term
  const filteredOptions = (options || []).filter(opt => String(opt).toLowerCase().includes(searchTerm.toLowerCase()));

  const handleToggle = e => {
    if (e) e.stopPropagation();
    setForm(prevForm =>
      prevForm.map((stepItem, sIdx) =>
        sIdx === step
          ? {
            ...stepItem,
            fields: stepItem.fields.map((f, fIdx) => (fIdx === index ? { ...f, open: !f.open } : f)),
          }
          : stepItem,
      ),
    );
  };

  const handleSelectOption = (option, e) => {
    if (e) e.stopPropagation();
    // Update value, close dropdown, and open next field in a single state update so the selected option stays visible
    handledropDownOptionClick(field, index, step, option);
  };

  const isCountryDropdown = field.placeHolder === "Select Country" || field.name === "Which country are you from?";
  return (
    <div
      className={`selection--wrapper ${isCountryDropdown ? "selection--wrapper--country" : ""}`}
      onClick={handleToggle}>
      <div style={{ width: "100%" }}>
        {field.open ? (
          <div className="dropdown-search-container" onClick={e => e.stopPropagation()}>
            {isCountryDropdown && (
              <input
                type="text"
                placeholder={field.placeHolder}
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="dropdown-search-input"
                autoFocus
              />
            )}
            <div className="dropdown-options-list">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, optionIndex) => (
                  <div key={optionIndex} className="selection--option-wrapper showDropdown">
                    <input
                      type="radio"
                      id={`${field.name}-${optionIndex}`}
                      value={option}
                      checked={option === field.value}
                      name={field.name}
                      onChange={e => handleSelectOption(option, e)}
                      style={{ cursor: "pointer", width: "14px", accentColor: "rgba(43, 147, 165, 1)" }}
                    />
                    <label
                      htmlFor={`${field.name}-${optionIndex}`}
                      style={{ cursor: "pointer", width: "100%", display: "inline-block" }}
                      onClick={e => handleSelectOption(option, e)}>
                      {makeTitleGeneric(option)}
                    </label>
                  </div>
                ))
              ) : (
                <div style={{ padding: "8px", color: "#666" }}>No results found</div>
              )}
            </div>
          </div>
        ) : field.value !== "" ? (
          <div className="selection--option-wrapper" style={{ flexWrap: "nowrap", overflow: "hidden" }}>
            <input type="radio" readOnly={true} checked />
            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {makeTitleGeneric(field.value)}
            </span>
          </div>
        ) : (
          <div style={{ width: "100%" }}>{field.placeHolder}</div>
        )}
      </div>
    </div>
  );
});

// Welcome banner slider data
const welcomeSlides = [
  {
    id: 1,
    line1: "Welcome to",
    brand: "HomeShiksha",
    line2: "Your Online Partner in Learning!",
    image: "./welcome_img.png",
    imageAlt: "Student learning online",
    bgColor: "#fcf1c6",
  },
  {
    id: 2,
    title: '<span style="color:#2b93a5;">Providing online tutoring services globally.</span>',
    image: "./welcome_img2.png",
    imageAlt: "Online tutoring globally",
    bgColor: "#B2D8F9",
  },
  {
    id: 3,
    title: '<span style="color: #2b93a5;">Get Online Tutors For</span>',
    description:
      '<span style="font-size: 24px; font-weight: 600">Academics, Dancing, Singing, Painting, Cooking, Yoga, Motivation Faculty, Children and co-curricular activities.</span>',
    image: "./welcome_img3.png",
    imageAlt: "Online tutors for all activities",
    bgColor: "#98E9D6",
  },
  {
    id: 4,
    title:
      '<span style="color: #1F222A !important">Specialized Online Support With our Special educators & Shadow teachers for</span> <span style="color: #2b93a5 !important">ADHD, ADD & Autism</span> <span style="color: #1F222A !important">Childern\'s</span>',
    image: "./welcome_img4.png",
    imageAlt: "Special education support",
    bgColor: "#C6D7FF",
  },
];

export default function OnlineTutor() {
  const [currentStep, setCurrentStep] = useState(0);
  const [apiData, setApiData] = useState([]);
  const [showTC, setShowTC] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [welcomeSlideIndex, setWelcomeSlideIndex] = useState(0);
  const touchStartRef = useRef(null);

  const handleTouchStart = e => {
    touchStartRef.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = e => {
    if (touchStartRef.current === null) return;
    const touchEnd = e.changedTouches[0].clientX;
    const distance = touchStartRef.current - touchEnd;
    const minSwipeDistance = 50;

    if (distance > minSwipeDistance) {
      // Left swipe (next)
      setWelcomeSlideIndex(prev => (prev + 1) % welcomeSlides.length);
    } else if (distance < -minSwipeDistance) {
      // Right swipe (prev)
      setWelcomeSlideIndex(prev => (prev - 1 + welcomeSlides.length) % welcomeSlides.length);
    }
    touchStartRef.current = null;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setWelcomeSlideIndex(prev => (prev + 1) % welcomeSlides.length);
    }, 10000);
    return () => clearInterval(timer);
  }, []);

  const [tutorSliderIndex, setTutorSliderIndex] = useState(0);
  const [sliderConfig, setSliderConfig] = useState({ max: Math.max(0, slides.length - 4), offset: 300 + 24 });
  useEffect(() => {
    const updateSliderConfig = () => {
      const mobile = window.matchMedia("(max-width: 768px)").matches;
      const smallMobile = window.matchMedia("(max-width: 480px)").matches;
      if (smallMobile) {
        setSliderConfig({ max: Math.max(0, slides.length - 1), offset: 260 + 24 });
      } else if (mobile) {
        setSliderConfig({ max: Math.max(0, slides.length - 1), offset: 280 + 24 });
      } else {
        setSliderConfig({ max: Math.max(0, slides.length - 4), offset: 300 + 24 });
      }
    };
    updateSliderConfig();
    window.addEventListener("resize", updateSliderConfig);
    return () => window.removeEventListener("resize", updateSliderConfig);
  }, []);
  const tutorSliderMax = sliderConfig.max;
  useEffect(() => {
    if (tutorSliderMax <= 0) return;
    const interval = setInterval(() => {
      setTutorSliderIndex(prev => (prev + 1) % (tutorSliderMax + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [tutorSliderMax]);

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const totalTestimonials = successStories.length;
  const [isMobileTestimonials, setIsMobileTestimonials] = useState(false);

  const handleNextTestimonial = useCallback(() => {
    setCurrentTestimonialIndex(prev => (prev + 1) % totalTestimonials);
  }, [totalTestimonials]);

  const handlePrevTestimonial = useCallback(() => {
    setCurrentTestimonialIndex(prev => (prev - 1 + totalTestimonials) % totalTestimonials);
  }, [totalTestimonials]);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => setIsMobileTestimonials(mq.matches);
    update();
    // Support older browsers
    if (mq.addEventListener) mq.addEventListener("change", update);
    else mq.addListener(update);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", update);
      else mq.removeListener(update);
    };
  }, []);

  const [Form, setForm] = useState([
    {
      viewed: true,
      filled: false,
      fields: [
        {
          type: "dropDown",
          open: true,
          name: "Choose Study Area",
          placeHolder: "Choose Study Area",
          options: [
            "school education",
            "Learn Language",
            "Curricular",
            "Competitive Exams",
            // 'Intermediate Courses',
            // 'Abroad Exams',
            "IT Courses",
            "Special Kids (ADHD /ADD /AUTISM)",
          ],
          value: "",
        },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "dropDown",
          open: false,
          name: "Prefered Tutor Gender",
          placeHolder: "Require Male/Female Tutor ?",
          options: ["I need only Male Tutor", "I need only Female Tutor", "Either Male or Female "],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "Mode of tuition",
          placeHolder: "Enter Your Mode of tuition",
          options: [
            "Looking for Online Tutor",
            // "Looking for Home Tutor",
            // "Either Home/Online Tutor",
          ],
          value: "Looking for Online Tutor",
        },
        {
          type: "dropDown",
          open: false,
          name: "How many days in a week you need tuition?",
          placeHolder: "Select days per week ",
          options: [
            "1 Day a week",
            "2 Days a week",
            "3 Days a week",
            "4 Days a week",
            "5 Days a week",
            "6 Days a week",
          ],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "When you would like to start ?",
          placeHolder: "Select Starting day",
          options: ["Immediately", "In Few Days", "In A Week", "In 10 Days", "In This Month", "Next Month"],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "Which country are you from?",
          placeHolder: "Select Country",
          options: [],
          value: "",
        },
        // {
        //   type: "address",
        //   name: "Location",
        //   placeHolder: "Location /Pin code / Latitude and Longitude",
        //   value: "",
        // },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "text",
          name: "First Name",
          placeHolder: "Enter Your First Name",
          value: "",
        },
        {
          type: "text",
          name: "Last Name",
          placeHolder: "Enter Your Last Name",
          value: "",
        },
        {
          type: "dropDown",
          open: true,
          name: " Your Gender",
          placeHolder: "Select Your Gender",
          options: ["male", "female"],
          value: "",
        },
        {
          type: "tel",
          name: "Mobile",
          placeHolder: "Enter Your Mobile Number",
          value: "",
        },
        {
          type: "email",
          name: "Email",
          placeHolder: "Enter Your Email",
          value: "",
        },
        {
          type: "checkbox",
          name: "",
          placeHolder: "",
          value: false,
        },
      ],
    },
  ]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("/v1/country");
        const body = response.data;

        // Use table shape: { data: [ { id, name, code, ... } ] }
        const list = Array.isArray(body?.data) ? body.data : Array.isArray(body) ? body : [];

        const countryNames = list
          .map(row => (row && (row.name || row.country_name || row.country)) || "")
          .filter(Boolean);

        if (countryNames.length === 0) return;

        setForm(prev =>
          prev.map((step, stepIndex) => {
            if (stepIndex !== 1) return step;
            return {
              ...step,
              fields: step.fields.map(field =>
                field.name === "Which country are you from?" ? { ...field, options: countryNames } : field,
              ),
            };
          }),
        );
      } catch (error) {
        console.error("Failed to fetch countries", error);
      }
    };

    fetchCountries();
  }, []);

  const submitTutorRequest = () => {
    let category_id = categorys[Form[0].fields[0].value];
    const step1Fields = Form[1]?.fields || [];
    const addressValue = step1Fields[5]?.value || {};
    const countryValue = step1Fields[4]?.value || "";

    let obj = {};
    if (category_id === "1" || category_id === "4") {
      obj = {
        level: Form[0].fields[1].value,
        stream_id: Form[0].fields[2].value,
        course: Form[0].fields[3].value,
        category_id: ["11th Class", "12th Class"].includes(Form[0].fields[1].value) ? "4" : "1",
      };
    } else {
      obj = {
        category_id,
        level: "Advanced Level",
        stream_id: Form[0].fields[1].value,
        course: Form[0].fields[2].value,
      };
    }
    obj = {
      ...obj,
      tutor_gender_preference: genderConversion[Form[1].fields[0].value],
      mode_of_tution: modeOfTutionconversion[Form[1].fields[1].value],
      days_per_week: Form[1].fields[2].value,
      when_to_start: Form[1].fields[3].value,

      first_name: Form[2].fields[0].value,
      last_name: Form[2].fields[1].value,
      gender: Form[2].fields[2].value,
      phone: Form[2].fields[3].value,
      email: Form[2].fields[4].value,

      country_name: countryValue,
      city_name: addressValue.city,
      state_name: addressValue.state,
      zip: addressValue.pincode,
      latitude: addressValue.latitude,
      longitude: addressValue.longitude,
    };

    const payloadPhone = Form[2].fields[3].value || "";
    const selectedCountry = Form[1]?.fields?.[4]?.value;
    const dialCode = selectedCountry ? countryDialCodes[selectedCountry] : "";
    const allDigits = String(payloadPhone).replace(/\D/g, "");
    const dialDigits = dialCode ? dialCode.replace(/\D/g, "") : "";
    const nationalDigits = dialDigits ? allDigits.slice(dialDigits.length) : allDigits;

    let isValidLength = false;
    let expectedLen = 0;

    if (selectedCountry && countryMobileLengths[selectedCountry]) {
      expectedLen = countryMobileLengths[selectedCountry];
      isValidLength = nationalDigits.length === expectedLen;
    } else {
      const e164 = allDigits.startsWith("+") ? allDigits : `+${allDigits}`;
      const parsed = parsePhoneNumberFromString(e164);
      const defaultCountry = parsed && parsed.country ? parsed.country : undefined;
      const lenResult = validatePhoneNumberLength(e164, defaultCountry);
      isValidLength = lenResult === undefined;
      if (!isValidLength && parsed) expectedLen = "the correct length for your country";
    }

    if (!isValidLength) {
      const msg = expectedLen
        ? `Please enter a valid ${expectedLen}-digit mobile number for ${selectedCountry}.`
        : "Please enter a valid mobile number before submitting.";
      alert(msg);
      return;
    }

    setIsSubmitting(true);
    axios
      .post("/v1/register", obj)
      .then(res => {
        console.log("Online tutor registration submitted", res.data);
        // If backend returns a JWT on registration, store it so user is logged in on dashboard
        const token = res.data?.data?.token ?? res.data?.token ?? res.data?.jwt;
        if (token) {
          localStorage.setItem("homeshiksha-jwt", JSON.stringify(token));
          navigate("/dashboard");
        } else {
          // No token: dashboard would redirect to login anyway, so go to login with a success message
          navigate("/", { state: { registrationSuccess: true } });
        }
      })
      .catch(err => {
        const data = err.response?.data;
        const isDuplicatePhone =
          data?.name === "SequelizeUniqueConstraintError" &&
          (data?.fields?.unique_phone_user_type != null ||
            data?.errors?.some?.(e => e.path === "unique_phone_user_type"));
        if (isDuplicatePhone) {
          alert(
            "This mobile number is already registered as a Student. Please use a different number or sign in with this number.",
          );
        } else {
          console.error(err);
          alert(data?.error?.msg || data?.message || "Registration failed. Please try again.");
        }
      })
      .finally(() => setIsSubmitting(false));
  };

  const fetchCourses = useCallback(
    (catId, courseLevel = "") => {
      axios
        .get("/v1/student/all-courses?category_id=" + categorys[catId])
        .then(response => {
          let dataFromAPI = response.data;
          setApiData(() => dataFromAPI);
          let _streamsList = dataFromAPI.map(itm => itm.stream_name);
          let _addedFields = [];
          const coursesList = dataFromAPI[0].courses.sort((a, b) => a.length - b.length);
          switch (catId) {
            case "school education":
              _addedFields.push({
                type: "dropDown",
                open: courseLevel === "",
                name: "For Which Class you need a Tutor ?",
                placeHolder: "For Which Class you need a Tutor ?",
                options: [
                  "Primary / Pre-Primary",
                  "LKG / UKG",
                  "1st Class",
                  "2nd Class",
                  "3rd Class",
                  "4th Class",
                  "5th Class",
                  "6th Class",
                  "7th Class",
                  "8th Class",
                  "9th Class",
                  "10th Class",
                  "11th Class",
                  "12th Class",
                ],
                value: courseLevel,
              });
              _addedFields.push({
                type: "dropDown",
                open: courseLevel !== "",
                name: "Choose the school board ?",
                placeHolder: "Choose the school board ?",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Intermediate Courses":
              _addedFields.push({
                type: "dropDown",
                open: courseLevel === "",
                name: "For Which Class you need a Tutor ?",
                placeHolder: "For Which Class you need a Tutor ?",
                options: [
                  "Primary / Pre-Primary",
                  "LKG / UKG",
                  "1st Class",
                  "2nd Class",
                  "3rd Class",
                  "4th Class",
                  "5th Class",
                  "6th Class",
                  "7th Class",
                  "8th Class",
                  "9th Class",
                  "10th Class",
                  "11th Class",
                  "12th Class",
                ],
                value: courseLevel,
              });
              _addedFields.push({
                type: "dropDown",
                open: courseLevel !== "",
                name: "Choose the school board ?",
                placeHolder: "Choose the school board ?",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Learn Language":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Stream",
                placeHolder: "Select Your Stream",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Curricular":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Stream",
                placeHolder: "Select Your Stream",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Competitive Exams":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Exam",
                placeHolder: "Select Your Exam",
                options: _streamsList,
                value: "",
              });

              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Special Kids (ADHD /ADD /AUTISM)":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Child Age group",
                placeHolder: "Child Age group",
                options: _streamsList,
                value: "",
              });

              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "IT Courses":
              _addedFields.push({
                type: "dropDown",
                open: false,
                name: "Stream",
                placeHolder: "Select Your Stream",
                options: _streamsList,
                value: _streamsList[0],
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: true,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            default:
              return;
          }
          setForm(pre => {
            let _Form = [...pre];
            _Form[0].fields = [_Form[0].fields[0], ..._addedFields];
            return _Form;
          });
        })
        .catch(err => { });
    },
    [setApiData, setForm],
  );

  const makeTitle = string => {
    return makeTitleGeneric(string);
  };

  const handledropDownOptionClick = useCallback(
    (field, index, step, option) => {
      setForm(prevForm => {
        // Build the new form state immutably
        let updatedForm = prevForm.map((stepItem, sIdx) => {
          if (sIdx !== step) return stepItem;

          // Clone the fields array and the target field
          const updatedFields = stepItem.fields.map((f, fIdx) => {
            if (fIdx === index) {
              return { ...f, value: option, open: false };
            }
            return f;
          });

          return { ...stepItem, viewed: true, fields: updatedFields };
        });

        // Auto-open next field if it's a dropdown and empty
        updatedForm = updatedForm.map((s, sIdx) => {
          if (sIdx !== step) return s;
          return {
            ...s,
            fields: s.fields.map((f, fIdx) => {
              if (fIdx === index + 1 && f.type === "dropDown" && f.value === "") {
                return { ...f, open: true };
              }
              return f;
            }),
          };
        });

        // Trigger side effects
        if (field.name === "Choose Study Area") {
          fetchCourses(option);
        }
        if (field.name === "For Which Class you need a Tutor ?") {
          const optStr = String(option).trim();
          const isSchool = [
            "Primary / Pre-Primary",
            "LKG / UKG",
            "1st Class",
            "2nd Class",
            "3rd Class",
            "4th Class",
            "5th Class",
            "6th Class",
            "7th Class",
            "8th Class",
            "9th Class",
            "10th Class",
          ].includes(optStr);
          fetchCourses(isSchool ? "school education" : "Intermediate Courses", option);
        }

        // Logic for opening dependent field lists based on stream/board selection
        if (
          ["Choose the school board ?", "Choose the college board ?", "Child Age group", "Stream", "Exam"].includes(
            field.name,
          )
        ) {
          const optionStr = String(option).trim().toLowerCase();
          const _courseList = apiData.find(
            d => d.stream_name && String(d.stream_name).trim().toLowerCase() === optionStr,
          );
          if (_courseList && Array.isArray(_courseList.courses)) {
            updatedForm = updatedForm.map((s, sIdx) => {
              if (sIdx !== step) return s;
              return {
                ...s,
                fields: s.fields.map((f, fIdx) => {
                  if (fIdx === index + 1) {
                    return {
                      ...f,
                      open: true,
                      options: [..._courseList.courses].sort((a, b) => a.length - b.length),
                    };
                  }
                  return f;
                }),
              };
            });
          }
        }

        // Logic for country selection to set mobile prefix
        if (field.name === "Which country are you from?") {
          const dialCode = countryDialCodes[option] || "";
          if (dialCode && updatedForm[2]?.fields?.[3]?.name === "Mobile") {
            updatedForm = updatedForm.map((s, sIdx) => {
              if (sIdx !== 2) return s;
              return {
                ...s,
                fields: s.fields.map((f, fIdx) => (fIdx === 3 ? { ...f, value: dialCode + " " } : f)),
              };
            });
          }
        }

        return updatedForm;
      });
    },
    [apiData, fetchCourses, setForm],
  );

  const handledropDownSelectOptionClick = (field, index, step, option, status) => {
    setForm(prevForm => {
      return prevForm.map((stepItem, sIdx) => {
        if (sIdx !== step) return stepItem;

        const updatedFields = stepItem.fields.map((f, fIdx) => {
          if (fIdx === index) {
            let newValue = [...f.value];
            const optionIndxInValueArray = newValue.indexOf(option);
            if (optionIndxInValueArray === -1 && !status) {
              newValue.push(option);
            } else if (optionIndxInValueArray !== -1 && status) {
              newValue.splice(optionIndxInValueArray, 1);
            }
            return { ...f, value: newValue };
          }
          // Also auto-open next field if applicable
          if (fIdx === index + 1 && f.type === "dropDown" && f.value === "") {
            return { ...f, open: true };
          }
          return f;
        });

        return { ...stepItem, viewed: true, fields: updatedFields };
      });
    });
  };

  const Step = step => (
    <div className="form--container">
      <form
        onSubmit={e => {
          e.preventDefault();
          let newForm = [...Form];
          let emptyField = [];
          newForm[step].fields.map(inpurField => {
            if (inpurField.value.length === 0) emptyField.push(inpurField.name);
            return inpurField;
          });
          if (emptyField.length === 0) {
            const isLastStep = step === Form.length - 1;
            if (isLastStep) {
              submitTutorRequest();
              setForm(pre => {
                newForm[step].filled = true;
                return newForm;
              });
            } else {
              setCurrentStep(pre => step + 1);
              setForm(pre => {
                newForm[step].filled = true;
                newForm[step + 1].viewed = true;
                try {
                  if (newForm[step + 1].fields[0].type === "dropDown" && newForm[step + 1].fields[0].value === "") {
                    newForm[step + 1].fields[0] = {
                      ...newForm[step + 1].fields[0],
                      open: true,
                    };
                  }
                } catch (error) {
                  console.log("error");
                }

                return newForm;
              });
            }
          } else {
            setForm(pre => {
              newForm[step].fields = newForm[step].fields.map(inputField => {
                if (inputField.value === "") return { ...inputField, open: true };
                return inputField;
              });
              return newForm;
            });
          }
          document.getElementById("find-a-tutor-form")?.scrollIntoView({ behavior: "smooth" });
        }}>
        {Form[step].fields.map((field, index, stepArray) => {
          let options = field.options;
          if (field.name === "Stream") {
            options = options.reverse();
          }
          let formComponent = <div>input failed </div>;
          switch (field.type) {
            case "dropDown":
              formComponent = (
                <SearchableDropdown
                  field={field}
                  index={index}
                  step={step}
                  options={options}
                  handledropDownOptionClick={handledropDownOptionClick}
                  setForm={setForm}
                />
              );
              break;
            case "dropDown-selection":
              let coursesList = field.options;
              if (stepArray[1].name === "For Which Class you need a Tutor ?") {
                if (["Primary / Pre-Primary", "LKG / UKG"].includes(stepArray[1].value)) coursesList = ["All Subjects"];
                else if (
                  ["1st Class", "2nd Class", "3rd Class", "4th Class", "5th Class", "6th Class", "7th Class"].includes(
                    stepArray[1].value,
                  )
                ) {
                  coursesList = coursesList.filter(
                    course =>
                      ![
                        "All Subjects",
                        "All Subjects Except Language",
                        "Physics",
                        "Chemistry",
                        "Biology",
                        "History",
                        "Geography",
                        "Political Science",
                      ].includes(course),
                  );
                  coursesList = ["All Subjects", "All Subjects Except Language", ...coursesList];
                } else if (["8th Class", "9th Class", "10th Class"].includes(stepArray[1].value))
                  coursesList = coursesList.filter(
                    course => !["All Subjects", "All Subjects Except Language"].includes(course),
                  );
                else if (["11th Class", "12th Class"].includes(stepArray[1].value))
                  coursesList = coursesList.filter(course => !["Science", "Accountancy"].includes(course));
              }
              formComponent = (
                <div className="selection--wrapper selection--wrapper--list">
                  {field.open ? (
                    <div className="dropdown-options-list" style={{ width: "100%" }}>
                      {coursesList.map((option, optionIndex) => (
                        <div
                          className={`selection--option-wrapper ${field.open ? "showDropdown" : "hideDropdown"}`}
                          key={optionIndex}>
                          <input
                            type="checkbox"
                            id={`${field.name}-${optionIndex}`} // Ensure unique IDs for each radio button
                            value={option}
                            checked={field.value.includes(option)}
                            name={field.name}
                            // required
                            onChange={e => {
                              if (e.target.value) {
                                handledropDownSelectOptionClick(
                                  field,
                                  index,
                                  step,
                                  e.target.value,
                                  field.value.includes(option),
                                );
                              }
                            }}
                            style={{
                              cursor: "pointer",
                              width: "14px",
                              accentColor: "rgba(43, 147, 165, 1)",
                              marginRight: "8px",
                            }}
                          />
                          <label
                            htmlFor={`${field.name}-${optionIndex}`}
                            style={{ cursor: "pointer", width: "100%", display: "inline-block" }}>
                            {makeTitle(option)}
                          </label>
                        </div>
                      ))}
                    </div>
                  ) : !field.value || field.value.length === 0 ? (
                    <div
                      onClick={() => {
                        setForm(pre => {
                          let newForm = [...pre];
                          newForm[step].fields[index].open = true;
                          return newForm;
                        });
                      }}
                      style={{ width: "100%" }}>
                      {field.placeHolder}
                    </div>
                  ) : (
                    <div
                      className={`selection--option-wrapper`}
                      onClick={() => {
                        setForm(pre => {
                          let newForm = [...pre];
                          newForm[step].fields[index].open = true;
                          return newForm;
                        });
                      }}
                      style={{ width: "100%" }}>
                      <input type="radio" readOnly={true} />
                      {field.value.map(opt => makeTitle(opt)).join(", ")}
                    </div>
                  )}
                </div>
              );
              break;
            case "address":
              formComponent = (
                <div>
                  <Autocomplete
                    apiKey={apiKey}
                    style={{ width: "99%" }}
                    onPlaceSelected={place => {
                      let addressComponents = place.address_components;
                      let pinCode = addressComponents.find(component => component.types.includes("postal_code"));
                      let city = addressComponents.find(
                        component => component.types.includes("locality") && component.types.includes("political"),
                      );
                      let state = addressComponents.find(
                        component =>
                          component.types.includes("administrative_area_level_1") &&
                          component.types.includes("political"),
                      );
                      let country = addressComponents.find(component => component.types.includes("country"));
                      let latitude = place.geometry.location.lat();
                      let longitude = place.geometry.location.lng();
                      let value = {
                        pincode: pinCode ? pinCode.short_name : " ",
                        city: city ? city.long_name : " ",
                        state: state ? state.long_name : " ",
                        country: country ? country.long_name : " ",
                        latitude: latitude,
                        longitude: longitude,
                      };
                      setForm(pre => {
                        let newForm = [...pre];
                        newForm[step].viewed = true;
                        newForm[step].fields[index] = {
                          ...field,
                          value: value,
                        };
                        return newForm;
                      });
                    }}
                    options={{
                      types: [
                        "hospital",
                        "pharmacy",
                        "bakery",
                        "sublocality",
                        ,
                        "landmark",
                        "locality",
                        "postal_code",
                        "postal_code_prefix",
                        "postal_code_suffix",
                        "postal_town",
                        "street_address",
                        "street_number",
                        "sublocality",
                        "sublocality_level_1",
                        "sublocality_level_2",
                        "sublocality_level_3",
                        "sublocality_level_4",
                        "sublocality_level_5",
                        "subpremise",
                        "town_square",
                      ],
                    }}
                    placeholder={field.placeHolder}
                  />
                </div>
              );
              break;

            case "checkbox":
              formComponent = (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  <input
                    required
                    type={field.type}
                    id={`${field.name}`}
                    name={`${field.name}`}
                    placeholder={`${field.placeHolder}`}
                    value={field.value}
                    onChange={e => {
                      let value = !field.value;
                      setForm(pre => {
                        let newForm = [...pre];
                        newForm[step].viewed = true;
                        newForm[step].fields[index] = {
                          ...field,
                          value: value,
                        };
                        return newForm;
                      });
                    }}
                  />
                  <span style={{ marginLeft: "8px", fontWeight: "600" }}>
                    I have read and accept{" "}
                    <span
                      onClick={() => {
                        document.getElementById("find-a-tutor-form")?.scrollIntoView({ behavior: "smooth" });
                        setShowTC(true);
                      }}
                      style={{
                        color: "navy",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}>
                      Student Terms and Conditions.
                    </span>
                  </span>
                  <dialog open={showTC} className="tc-dialog-box">
                    <br />
                    <br />
                    1. You understand that HomeShiksha is a home tutoring marketplace and will facilitate the finding of
                    a quality home tutor for your child.Home Shiksha is 100% free to the parents/students.
                    <br />
                    <br />
                    2. You can contact the tutors directly and invite them to conduct a free demo class. A tutor will
                    conduct only 1 or maximum 2 free demo classes. After the demo class Student / Parent has to be
                    informed to the HomeShiksha/tutor as to be continued or not continued.
                    <br />
                    <br />
                    3. After first demo if you wish to continue with our tutor.For Bangalore, Dehradun, Raipur, Chennai
                    and Vijayawada : You have to pay 50% of the tuition fee as advanced payment to HomeShiksha for
                    confirmation. From 2nd month you can pay at the month end.For Hyderabad: You have to pay 100%
                    advanced payment to HomeShiksha for confirmation. From 2nd month you can pay at the month
                    end.Student / Parent do not pay any advances to the Selected Tutor directly. HomeShiksha is not
                    responsible if the existed tutor is not turning back after taking the Advance.
                    <br />
                    <br />
                    4. In consideration of the home tuition provided by the tutor to your child, you agree to pay a
                    predefined amount to the tutor.Also if parents want to discontinue the tuition at any time(before
                    completetion of month) then they need to pay the charges for exact number of days the tutor came to
                    teach.In case if its the starting month then they need to pay the charges for exact number of days
                    the tutor came to teach including the demo class.
                    <br />
                    <br />
                    5. You understand that, to the extent possible, HomeShiksha will facilitate finding a tutor that
                    best suit your child's requirement but it does not guarantee any success of any kind in any
                    examination or test that your child may undertake.
                    <br />
                    <br />
                    6. You understand that in the case where the tutor fails to deliver first 15 scheduled tuitions,
                    Homeshiksha will facilitate finding a replacement tutor for your child within a reasonable period of
                    time.
                    <br />
                    <br />
                    7. You understand that home tutors need to be treated with respect and dignity. Further, you agree
                    to provide in your home an environment conducive to one on one study during the currency of the said
                    home tuition.
                    <br />
                    <br />
                    8. You understand that the final decision to choose a particular tutor for your child is yours and
                    yours alone. You explicitly agree to indemnify HomeShiksha from any harm that may be caused by any
                    advertent or inadvertent actions of the tutor.
                    <br />
                    <br />
                    9. You understand that the tutor will teach your child if and only if at least one parent is present
                    in the house.
                    <br />
                    <br />
                    10. HomeShiksha will not give any guarantee of the Student's progress and also not responsible if
                    any stolen things happen by the tutor.Tutors being observed by the parents / Care Takers during the
                    tuition time.
                    <br />
                    <br />
                    11. HomeShiksha reserves all the rights to change all or any of these above mentioned terms and
                    conditions with or without giving any prior notice.
                    <br />
                    <br />
                    <button
                      onClick={() => {
                        document.getElementById("find-a-tutor-form")?.scrollIntoView({ behavior: "smooth" });
                        setShowTC(false);
                      }}>
                      Got It
                    </button>
                  </dialog>
                </div>
              );
              break;
            default:
              formComponent = (
                <input
                  required
                  type={field.type}
                  id={`${field.name}`}
                  name={`${field.name}`}
                  placeholder={`${field.placeHolder}`}
                  value={field.value}
                  maxLength={field.type === "tel" ? 20 : undefined}
                  onChange={e => {
                    let value = e.target.value;
                    if (field.type === "tel") {
                      // Allow only numbers, spaces, plus signs, and hyphens to support country codes
                      value = value.replace(/[^\d+\s-]/g, "");

                      if (field.name === "Mobile") {
                        try {
                          // Keep prefix in sync with selected country when present
                          // Country is index 4 in Step 1 (Form[1].fields[4])
                          const selectedCountry = Form[1]?.fields?.[4]?.value;
                          const dialCodeFromForm = selectedCountry ? countryDialCodes[selectedCountry] : "";
                          const prefixFromForm = dialCodeFromForm ? `${dialCodeFromForm} ` : "";
                          if (prefixFromForm && !value.startsWith(prefixFromForm)) {
                            value = prefixFromForm;
                          }

                          const allDigits = value.replace(/\D/g, "");
                          const prefixInValue = (value.trim().match(/^\+\d+/) || [""])[0];
                          let dialDigits = prefixInValue ? prefixInValue.replace(/\D/g, "") : "";
                          if (!dialDigits && allDigits.length > 0) {
                            const parsed = parsePhoneNumberFromString(`+${allDigits}`);
                            if (parsed) dialDigits = parsed.countryCallingCode;
                          }

                          if (dialDigits && allDigits.length > 0) {
                            let nationalDigits = allDigits.slice(dialDigits.length);
                            let e164 = `+${dialDigits}${nationalDigits}`;

                            // Dynamic check: mapping first, then libphonenumber
                            let maxLen = 15; // default max
                            if (selectedCountry && countryMobileLengths[selectedCountry]) {
                              maxLen = countryMobileLengths[selectedCountry];
                            } else {
                              const parsed = parsePhoneNumberFromString(e164);
                              const defaultCountry = parsed && parsed.country ? parsed.country : undefined;
                              const lenResult = validatePhoneNumberLength(e164, defaultCountry);
                              if (lenResult === "TOO_LONG") {
                                // Find max valid length
                                while (nationalDigits.length > 0) {
                                  nationalDigits = nationalDigits.slice(0, -1);
                                  e164 = `+${dialDigits}${nationalDigits}`;
                                  if (validatePhoneNumberLength(e164, defaultCountry) !== "TOO_LONG") {
                                    maxLen = nationalDigits.length;
                                    break;
                                  }
                                }
                              } else if (lenResult === undefined) {
                                maxLen = nationalDigits.length;
                              }
                            }

                            if (nationalDigits.length > maxLen) {
                              nationalDigits = nationalDigits.slice(0, maxLen);
                            }

                            const displayPrefix = prefixInValue || dialCodeFromForm || `+${dialDigits}`;
                            value = `${displayPrefix} ${nationalDigits}`;
                          }
                        } catch (e) {
                          console.log("Error enforcing mobile prefix:", e);
                        }
                      }
                    }
                    setForm(pre => {
                      let newForm = [...pre];
                      newForm[step].viewed = true;
                      newForm[step].fields[index] = {
                        ...field,
                        value: value,
                      };
                      return newForm;
                    });
                  }}
                />
              );
          }

          return (
            <div key={index}>
              <div className="input-group">
                <label htmlFor={`${field.name}`}>{field.name}</label>
                {formComponent}
              </div>
            </div>
          );
        })}

        <div className="form-buttons-wrapper">
          {currentStep > 0 && (
            <button className="secondary-btn" type="button" onClick={e => setCurrentStep(step - 1)}>
              Previous
            </button>
          )}
          {currentStep < Form.length - 1 && (
            <button className="primary-btn" type="submit" disabled={isSubmitting}>
              Next
            </button>
          )}
          {currentStep === Form.length - 1 && (
            <button className="primary-btn" type="submit" disabled={isSubmitting}>
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );

  function getRandomRGBColor() {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b},.35)`;
  }

  useEffect(() => {
    let jwt = JSON.parse(localStorage.getItem("homeshiksha-jwt"));
    if (!jwt) {
      localStorage.setItem("userDetails", JSON.stringify({}));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/dashboard");
      window.location.reload();
    }
  }, []);

  return (
    <main className="main online-tutor">
      <div className="slider-welcome">
        <section
          className="welcome-top"
          aria-label="Welcome banner"
          style={{ background: welcomeSlides[welcomeSlideIndex].bgColor, transition: "background 0.6s ease" }}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}>
          {welcomeSlides.map((slide, i) => (
            <div
              key={slide.id}
              className={`welcome-top__inner welcome-top__inner--slide-${slide.id}`}
              style={{
                opacity: i === welcomeSlideIndex ? 1 : 0,
                position: i === 0 ? "relative" : "absolute",
                top: 0,
                left: 0,
                width: "100%",
                pointerEvents: i === welcomeSlideIndex ? "auto" : "none",
                transition: "opacity 0.6s ease",
              }}>
              <div className="online-tutor-welcome-top--leftpart-wrapper">
                {(slide.line1 || slide.brand) && (
                  <div className="welcome-top__heading-group">
                    {slide.line1 && <span className="welcome-top__line1">{slide.line1}</span>}
                    {slide.brand && <span className="welcome-top__brand">{slide.brand}</span>}
                  </div>
                )}
                {slide.line2 && <span className="welcome-top__line2">{slide.line2}</span>}
                {slide.title && (
                  <span className="welcome-top__title" dangerouslySetInnerHTML={{ __html: slide.title }} />
                )}
                {slide.description && (
                  <span className="welcome-top__description" dangerouslySetInnerHTML={{ __html: slide.description }} />
                )}
                {slide.button && (
                  <button
                    type="button"
                    className="welcome-top__cta-btn"
                    onClick={() => {
                      if (slide.button === "Need a Tutor") navigate("/need-a-tutor");
                    }}>
                    {slide.button}
                  </button>
                )}
              </div>
              <div className="online-tutor-welcome-top--img">
                <img src={slide.image} alt={slide.imageAlt} />
              </div>
            </div>
          ))}
        </section>
        <div className="welcome-slider__indicators">
          {welcomeSlides.map((_, i) => (
            <div
              key={i}
              className={`welcome-slider__indicator ${i === welcomeSlideIndex ? "active" : ""}`}
              onClick={() => setWelcomeSlideIndex(i)}
            />
          ))}
        </div>
      </div>

      <section className="top-session" id="find-a-tutor-form">
        <div className="online-tutor-top-session--leftpart-wrapper">
          <div className="online-tutor-biglogo--wrapper">
            <img src="./learning_online_concept 2.png" alt="learning-online-concept-2 pic" />

            <div className="online-tutor-biglogo--title">
              <span className="title-brand">Homeshiksha:</span>{" "}
              <span className="education-per">Your Trusted Partner in Personalized Education</span>
            </div>
          </div>
        </div>
        <div className="online-tutor-top-session--rightpart-wrapper">
          <div className="online-tutor-top-session--rightpart--form-wrapper form--container">
            <div className="form_title">find a tutor</div>
            <div className="form-status--wrapper">
              <div className="steps-wrapper">
                {Form.map((item, index) => (
                  <div className="step-status-wrapper" key={index}>
                    <div
                      onClick={e => {
                        if (Form[index].viewed) setCurrentStep(pre => index);
                      }}>
                      Step {index + 1}{" "}
                    </div>
                    <div
                      onClick={e => {
                        if (Form[index].viewed) setCurrentStep(pre => index);
                      }}
                      className={`step-status-circle ${Form[index].viewed ? "blue-border" : ""
                        } ${Form[index].filled ? "blue-bg" : ""}`}></div>
                  </div>
                ))}
              </div>
              <div className="line-wrapper-under-steps-wrapper"></div>
            </div>
            <div className="form--wrapper">{Step(currentStep)}</div>
          </div>
        </div>
      </section>
      <TutoringCountries />
      <ExploreCategoriesSection />

      <section className="tutor-section">
        <TutorRegistration />
      </section>

      <DemoClass />

      <section className="process-section">
        <div className="process-header">
          <h2 className="process-heading">
            Easy Steps To <span className="process-heading-highlight">Excellence</span>
          </h2>
          <p className="process-subheading">Call us or follow the following steps for finding best online tutor.</p>
        </div>
        <div className="process-wrapper">
          {/* STEP 01 */}
          <article className="process-step">
            <div className="process-step-label">STEP 01</div>
            <img className="process-step-icon" src="./step1.gif" alt="Submit details icon" />
            <div className="process-step-content">
              <h3 className="process-step-title">1. Submit Details</h3>
              <p className="process-step-text">Call us/click on Need a Tutor to share your requirements.</p>
            </div>
          </article>
          {/* STEP 02 */}
          <article className="process-step">
            <div className="process-step-label">STEP 02</div>
            <img className="process-step-icon" src="./step2.gif" alt="Instant response icon" />
            <div className="process-step-content">
              <h3 className="process-step-title">2. Instant Response</h3>
              <p className="process-step-text">
                HomeShiksha executive will contact you within 1–2 working hours to discuss your needs.
              </p>
            </div>
          </article>
          {/* STEP 03 */}
          <article className="process-step">
            <div className="process-step-label">STEP 03</div>
            <img className="process-step-icon" src="./step3.gif" alt="Free demo icon" />
            <div className="process-step-content">
              <h3 className="process-step-title">3. Free Demo</h3>
              <p className="process-step-text">
                Our HomeShiksha executive will provide the free online demo class from our expert / verified tutors.
              </p>
            </div>
          </article>
          {/* STEP 04 */}
          <article className="process-step">
            <div className="process-step-label">STEP 04</div>
            <img className="process-step-icon" src="./step4.gif" alt="Confirm tutor icon" />
            <div className="process-step-content">
              <h3 className="process-step-title">4. Confirm</h3>
              <p className="process-step-text">
                Choose the expert tutor and start the online class and be free from your worries.
              </p>
            </div>
          </article>
        </div>
      </section>

      <WhyChooseHomeShiksha />

      <PerfectOnlineTutors />

      <section className="tutor-cta-section">
        <div className="tutor-cta-wrapper">
          <div className="tutor-cta-content">
            <div className="tutor-cta-text">
              <h2 className="tutor-cta-heading">
                Specialized Online Support for Autism, ADHD, Dyslexia & Special Needs
              </h2>
              <p className="tutor-cta-subheading">
                Empowering Every Child's Learning Journey with Tailored, Compassionate Support
              </p>
            </div>
            <button className="tutor-cta-button">
              <span>Book Now</span>
            </button>
          </div>
          <div className="tutor-cta-visual">
            {/* Replace with the exported illustration that matches 11672032_13272 2 */}
            <img src="./student_regis.png" alt="student-regis pic" />
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <h2 className="testimonial-heading">
          Real Stories of <span>Success</span>
        </h2>
        <div className="testimonial-frame">
          {/* Illustration */}
          <div className="testimonial-illustration">
            <img src="./online_communication.png" alt="Happy students and parents sharing success stories" />
          </div>
          {/* Manual slider (no auto-advance): 1 card on mobile, 2 on desktop */}
          <div className="testimonial-slider-wrapper" aria-label="Student and parent testimonials">
            <div
              className="testimonial-nav-arrow-left"
              onClick={handlePrevTestimonial}
              aria-label="Previous testimonial">
              <img src="/arrow_capa.png" alt="" className="testimonial-nav-arrow-img" />
            </div>

            <div className="testimonials-slider">
              {(isMobileTestimonials ? [0] : [0, 1]).map(offset => {
                const index = (currentTestimonialIndex + offset) % totalTestimonials;
                const story = successStories[index];

                return (
                  <article key={story.id} className="testimonial-card">
                    <p className="testimonial-card-text">{story.text}</p>
                    <div className="testimonial-card-info">
                      <img src={story.avatarSrc} alt={story.avatarAlt} className="testimonial-avatar" />
                      <div className="testimonial-name-block">
                        <div className="testimonial-name">{story.name}</div>
                        <div className="testimonial-role">{story.role}</div>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>

            <div className="testimonial-nav-arrow-right" onClick={handleNextTestimonial} aria-label="Next testimonial">
              <img src="/arrow_capa_right.png" alt="" className="testimonial-nav-arrow-img" />
            </div>
          </div>
        </div>
      </section>

      <section className="certified-by-india-section">
        <div className="certified-top-heading">
          Endorsed <span style={{ color: "black" }}>and</span> Certified
        </div>

        <div className="certified-banner">
          <div className="certified-banner-text">
            <p>We are now incubated with</p>
            <p className="certified-banner-highlight">IIM BANGALORE</p>
          </div>
          <div className="certified-banner-logo">
            <img src="./IIM_cert.png" alt="IIM Bangalore logo" />
          </div>
        </div>

        <div className="certified-by-india-section--title">Certified by Indian Government</div>
        {/* <div className="certified-by-india-section--midline"></div> */}
        <div className="certified-by-india-section--imgs-wrapper">
          <div>
            <img src="./msme-img.png" alt="msme img" />
          </div>
          <div>
            <img src="./startupindia-img.png" alt="start up india img" />
          </div>
        </div>
      </section>

      <section className="blog-section">
        <header className="blog-section-header">
          <h2 className="blog-section-heading">
            <span>
              Featured Achievements <span style={{ color: "black" }}>&</span> Published Insights
            </span>
          </h2>
        </header>

        <div className="blog-section-cards">
          {blogPosts1.map(post => (
            <BlogCard
              key={post.id}
              imageSrc={post.imageSrc}
              imageAlt={post.imageAlt}
              category={post.category}
              title={post.title}
              description={post.description}
              href={post.link}
            />
          ))}
        </div>
      </section>
      <section className="contact-us-section">
        <div className="contact-us-header">
          <h2 className="contact-us-heading">Frequent asked questions</h2>
        </div>
        <div className="contact-us-faq-wrapper">
          <Faq data={data} styles={styles} config={config} />
        </div>
      </section>

      <section className="footer-section">
        <FooterPage />
      </section>
    </main>
  );
}
